import ProductList from "@/components/ProductList/v2/ProductList"
import React from "react"
import { useQuizContext } from "./QuizContext"
import { getFilterQuery, plpConfig as defaultConfig, sections } from "./helper"
import backArrow from "@/public/icons/arrow-right-black.svg"

const QuizResults = () => {
  const attrName = []
  const attrValue = []
  const { data = {}, setSection } = useQuizContext()
  const { questions = [], resultTitle, resultDescription } = data
  const queries = getFilterQuery(questions, "array")

  queries.forEach(query => {
    attrName.push(query.key)
    attrValue.push(query.value)
  })

  const plpConfig = {
    categoryKey: data?.plpCategory?.replace("PLP_", ""),
    attributeName: attrName,
    attributevalue: attrValue,
    ...defaultConfig,
  }

  return (
    <div className="quiz-results">
      <div className="kf-react-plp-container">
        <div className="row">
          <div className="col-12">
            <button
              className="back-button"
              onClick={() => setSection(sections.LANDING)}
            >
              <img src={backArrow.src} alt="close" /> Back to home
            </button>
            <h2 className="title">{resultTitle}</h2>
            <p className="desc">{resultDescription}</p>
          </div>
        </div>
      </div>
      <ProductList data={plpConfig} />
    </div>
  )
}

export default QuizResults
